import { ExtractEventType } from './../extract.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
	selector: 'app-month-filter',
	templateUrl: './month-filter.component.html',
	styleUrls: ['./month-filter.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MonthFilterComponent implements OnInit {

	slideConfig = {
		slidesToShow : 8,
		slidesToScroll: 1,
		initialSlide: 4,
		arrows: true,
		dots: false,
		infinite: false,
		prevArrow : '<button type="button" class="slick-prev material-icons arrow"><span>&#xE5C5;</span></button>',
		nextArrow : '<button type="button" class="slick-next material-icons arrow"><span>&#xE5C5;</span></button>',
		draggable: false
	};

	months = Array<object>();
	monthsAll = Array<object>();
	monthId: number;

	constructor(private router: Router, private route: ActivatedRoute) {

		moment.locale('pt-br');
		const monthsNames = moment.monthsShort();

		let i = 0;
		for (const name of monthsNames) {
			i++;
			this.monthsAll.push({name});
		}

		this.setMonths();
	}

	setMonths() {
		const today = new Date();
		let actualDate;
		let monthNum;
		let monthText;
		let year;
		for (let i = 12; i > 0; i -= 1) {
			actualDate = new Date(today.getFullYear(), today.getMonth() + 1 - i, 1);
			monthNum = ('0' + (actualDate.getMonth() + 1)).slice(-2);
			monthText = this.monthsAll[actualDate.getMonth()];
			year = actualDate.getFullYear();
			this.months.push({ monthText, month: monthNum, year: year });
		}
	}

	ngOnInit() {
		this.getMonthId();
	}

	getMonthId() {
		this.route.params.subscribe(params => {
			this.monthId = params.month;
		});
	}

	loadByMonth(month) {
		this.router.navigate(['extrato/mes', month.month, month.year]);
		this.getMonthId();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/extract/month-filter/month-filter.component.ts